
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              event.preventDefault();
              const target = event.currentTarget;
              const social = target.getAttribute('data-social');
              window.open(social);
            }, false);
        });
        this.querySelectorAll('.btn-copy-link').forEach(btn => {
            btn.addEventListener("click", event => {
              event.preventDefault();
              const url = event.currentTarget.getAttribute('data-url');
              const tooltip = event.currentTarget.querySelector('.tooltip-content');
              const onSuccess = () => {
                if (tooltip) {
                  const orig = tooltip.textContent;
                  tooltip.textContent = tooltip.dataset.copiedText || "Kopiert!";
                  setTimeout(() => { tooltip.textContent = orig; }, 1500);
                }
              };
              const fallback = () => {
                if (window.theme && window.theme.fallbackCopy) {
                  window.theme.fallbackCopy(url);
                } else {
                  const ta = document.createElement("textarea");
                  ta.value = url;
                  ta.style.position = "fixed";
                  ta.style.opacity = "0";
                  document.body.appendChild(ta);
                  ta.select();
                  document.execCommand("copy");
                  document.body.removeChild(ta);
                }
              };
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(onSuccess).catch(() => {
                  fallback();
                  onSuccess();
                });
              } else {
                fallback();
                onSuccess();
              }
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);
  